/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file The Overlay View component
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@-webkit-keyframes slideIn{0%{top:-400px}to{top:0}}@keyframes slideIn{0%{top:-400px}to{top:0}}.sym-overlay[_ngcontent-%COMP%]{position:absolute;width:100%;min-height:100%;top:0;left:0;right:0;background-color:rgba(0,0,0,.5);z-index:99999}.sym-overlay[_ngcontent-%COMP%]   .sym-overlay-view[_ngcontent-%COMP%]{background-color:#fff;position:relative;-webkit-animation:slideIn 1s;animation:slideIn 1s;cursor:default}.sym-overlay[_ngcontent-%COMP%]   .sym-overlay-view[_ngcontent-%COMP%]     .sym-entity-link{display:none}"];
export { styles as styles };
